import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Checkbox,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import InputForm from "./_input-form";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  subtitle: {
    display: "inline",
    color: theme.palette.ePrimary.base,
  },
  displayInline: {
    display: "inline",
  },
  checkBox: {
    padding: "0",
    marginLeft: "2rem",
    marginRight: "0.3rem",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "0.5rem !important",
    },
  },
  disabledColor: {
    color: theme.palette.eDark.base
  },
  boxStyle: {
    display: "flex",
    alignItems: "center"
  }
}));

export default function MailingAddress(props) {
  const { divisionList, 
    districtMailing, address1Mailing, address2Mailing, postOfficeMailing, divisionMailing, countryMailing, postCodeMailing, thanaMailing,
    setDistrictMailing, setAddress1Mailing, setAddress2Mailing, setPostOfficeMailing, setDivisionMailing, setDivisionCodeMailing, setCountryMailing, setPostCodeMailing, setThanaMailing,
    sameAsPremiseCheck, setSameAsPremiseCheck, checkBoxHandler, checkBoxEnable, setStateCodeMailing,districtdropdown, setdistrictdropdown,thanadropdown, setthanadropdown,

 existingCustomer  , masterDataAddress1Mailing,masterDataAddress2Mailing,masterDataPostOfficeMailing,masterDataPostCodeMailing,masterDataDistrictMailing,
 masterDataDivisionCodeMailing,
 masterDataDivisionMailing,
 masterDataThanaMailing,
  } = props;
  let classes = useStyles();
  let labels = useSelector(
    (store) => store?.labels?.data?.getLabels?.E_PREMISE_DETAILS
  );
  const { t: premiseLabel,ready: labelReady } = useTranslation("label-E_PREMISE_DETAILS");
  return (
    <Grid container>
      <Box pb={2} className={classes.boxStyle}>
      {
        labelReady ?
        <Typography variant="subtitle2" className={classes.subtitle}>
          <b>{premiseLabel("E_PREMISE_COMMUNICATION_DETAILS")}</b>
        </Typography>
        : <Skeleton />
      } 
        <Checkbox
          value="checkedA"
          checked={sameAsPremiseCheck}
          disabled={!checkBoxEnable || existingCustomer=="yes"}
          className={[classes.checkBox]}
          inputProps={{ "aria-label": "Checkbox A" }}
          onChange={checkBoxHandler}
          color="default"
        />
        <Typography variant="subtitle2" className={[classes.displayInline, !checkBoxEnable && classes.disabledColor]}>
          <b> {labels?.E_PREMISE_DETAILS_SAME_AS_PREMISE}</b>
        </Typography>
      </Box>
      <Grid item>
        <InputForm
        districtdropdown={districtdropdown}
        setdistrictdropdown={setdistrictdropdown}
        thanadropdown={thanadropdown}
         setthanadropdown={setthanadropdown}
          divisionList={divisionList}
          district={districtMailing}
          address1={address1Mailing}
          address2={address2Mailing}
          postOffice={postOfficeMailing}
          division={divisionMailing}
          setStateCodeMailing={setStateCodeMailing}
          country={countryMailing}
          postcode={postCodeMailing}
          thana={thanaMailing}
          setDistrict={setDistrictMailing}
          setAddress1={setAddress1Mailing}
          setAddress2={setAddress2Mailing}
          setPostOffice={setPostOfficeMailing}
          setDivision={setDivisionMailing}
          setDivisionCode={setDivisionCodeMailing}
          setCountry={setCountryMailing}
          setPostCode={setPostCodeMailing}
          setThana={setThanaMailing}
          sameAsPremiseCheck={sameAsPremiseCheck}
          existingCustomer={existingCustomer}
          masterDataAddress1Mailing={masterDataAddress1Mailing}
          masterDataAddress2Mailing={masterDataAddress2Mailing}
          masterDataPostOfficeMailing={masterDataPostOfficeMailing}
          masterDataPostCodeMailing={masterDataPostCodeMailing}
          masterDataDistrictMailing={masterDataDistrictMailing}
          masterDataDivisionCodeMailing={masterDataDivisionCodeMailing}
          masterDataDivisionMailing={masterDataDivisionMailing}
          masterDataThanaMailing={masterDataThanaMailing}
        ></InputForm>
      </Grid>
    </Grid>
  );
}